// extracted by mini-css-extract-plugin
module.exports = {"root":"GroupLabel_root__3pYcs"};